import JSZip from "jszip";

import {getExtensionFromBlobType} from "@/fonction/getExtension";
import {getCSRF_Token} from "@/fonction/logConnection";
import {Contrat} from "@/ts/contrat";

import {callApi} from "./_callApi";

export async function uploadFichierContrat(
  API: string | undefined,
  contratId: number,
  body: FormData,
  currentContremarque?: string
): Promise<Contrat> {
  try {
    const reponse = await callApi(
      `${API}/api/coact/v1/contrats/${contratId}/fichiers`,
      "POST",
      {
        "X-CSRF-Token": getCSRF_Token(),
        ...(currentContremarque
          ? {"X-Coact-Contremarque": currentContremarque}
          : {}),
      },
      "include",
      body,
      true,
      false
    );

    return reponse as Contrat;
  } catch (error: any) {
    throw new Error(error?.message);
  }
}

export async function deleteFichier(
  API: string | undefined,
  fichierId: number
): Promise<void> {
  try {
    await callApi(
      `${API}/api/coact/v1/fichiers/${fichierId}`,
      "DELETE",
      {
        "X-CSRF-Token": getCSRF_Token(),
      },
      "include",
      {},
      false,
      false
    );
  } catch (error: any) {
    throw new Error(error?.message);
  }
}

export async function downloadFichier(
  API: string | undefined,
  fichierId: number | number[],

  currentContremarque?: string,
  labelFile?: string
): Promise<void> {
  // Cas 1 : un seul fichier -> comportement existant
  if (!Array.isArray(fichierId)) {
    try {
      const reponse = await callApi(
        `${API}/api/coact/v1/fichiers/${fichierId}`,
        "GET",
        {
          "X-CSRF-Token": getCSRF_Token(),
          ...(currentContremarque
            ? {"X-Coact-Contremarque": currentContremarque}
            : {}),
        },
        "include",
        null,
        false,
        false
      );
      if (reponse.status !== 200) {
        throw new Error("Erreur lors du téléchargement du fichier");
      }

      const blob = await reponse.blob();

      const contentDisposition = reponse.headers.get("Content-Disposition");
      console.log("headers", reponse.headers.get("Content-Disposition"));
      let filename = `${labelFile ? labelFile : "fichier_" + fichierId}`;

      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(
          /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
        );
        if (filenameMatch && filenameMatch[1]) {
          filename = filenameMatch[1].replace(/['"]/g, "");
        }
      }

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      console.log("filename", filename);
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error: any) {
      throw new Error(error?.message);
    }
    return;
  }

  // Cas 2 : plusieurs fichiers -> on crée un ZIP
  try {
    const zip = new JSZip();

    for (const id of fichierId) {
      const reponse = await callApi(
        `${API}/api/coact/v1/fichiers/${id}`,
        "GET",
        {
          "X-CSRF-Token": getCSRF_Token(),
          ...(currentContremarque
            ? {"X-Coact-Contremarque": currentContremarque}
            : {}),
        },
        "include",
        null,
        false,
        false
      );

      if (reponse.status !== 200) {
        throw new Error(`Erreur lors du téléchargement du fichier (id: ${id})`);
      }

      const blob = await reponse.blob();

      // On récupère un nom de fichier pour chaque entrée
      const contentDisposition = reponse.headers.get("Content-Disposition");
      console.log("headers", reponse.headers.get("Content-Disposition"));
      let filename = `fichier_${fichierId.indexOf(id) + 1}.${getExtensionFromBlobType(blob)}`;

      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(
          /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
        );
        if (filenameMatch && filenameMatch[1]) {
          filename = filenameMatch[1].replace(/['"]/g, "");
        }
      }

      const arrayBuffer = await blob.arrayBuffer();
      zip.file(filename, arrayBuffer);
    }

    // Générer le ZIP et le télécharger
    const zipBlob = await zip.generateAsync({type: "blob"});
    const url = window.URL.createObjectURL(zipBlob);
    const link = document.createElement("a");
    link.href = url;
    link.download = labelFile ?? "fichiers.zip";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error: any) {
    throw new Error(error?.message);
  }
}
